<template>
    <div class="message-centre-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <h4 class="page-title" id="page_title"><span v-if="company">{{ company.name }}</span> Users</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <users-table/>
        </div>
    </div>
</template>

<script>
    import UsersTable from "@/components/main/data-tables/UsersTable";
    import Company from "@/models/company";

    export default {
        components: {
            UsersTable
        },
        data() {
            return {
                company: null
            }
        },
        created() {
            this.initCompany()
        },
        methods: {
            initCompany() {
                Company.find(this.$route.params.company_id)
                    .then((response) => {
                        this.company = response;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
